import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/common/girl.png';
const _withScopeId = n => (_pushScopeId("data-v-1ec40374"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "now"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "con"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-right"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$dic.now[_ctx.$route.name].title || '开始体验我们的服务！'), 1), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleGo && $options.handleGo(...args))
  }, [_createTextVNode(_toDisplayString(_ctx.$dic.now[_ctx.$route.name].btn || '立即体验') + " ", 1), _hoisted_5])])]);
}